import { For } from "solid-js"
import { useLanguage } from "@/context/language"
import { describeProgress, type OperationProgress } from "@/cowork/progress"

export function CoworkProgressDetails(props: { progress: OperationProgress }) {
  const language = useLanguage()
  return (
    <For each={describeProgress(props.progress, language.t)}>
      {(line, index) => (
        <div
          class={
            index() === 0
              ? "text-v2-text-text-base"
              : "mt-0.5 break-words text-v2-text-text-muted [overflow-wrap:anywhere]"
          }
        >
          {line}
        </div>
      )}
    </For>
  )
}
